<script setup lang="ts">
const { t } = useI18n()
const collapseList = computed(() => {
  return [
    { id: 7, title: t('Title.FAQ7'), content: t('Copywriting.FAQ7') },
    { id: 8, title: t('Title.FAQ8'), content: t('Copywriting.FAQ8') },
    { id: 9, title: t('Title.FAQ9'), content: t('Copywriting.FAQ9') },
    {
      id: 10,
      title: t('Title.FAQ10'),
      content: t('Copywriting.FAQ10'),
    },
    { id: 1, title: t('Title.HowMuchMoney'), content: t('Copywriting.HowMuchMoney') },
    { id: 2, title: t('Title.WhatPaymentMethods'), content: t('Copywriting.WhatPaymentMethods') },
    { id: 3, title: t('Title.CryptocurrencySafe'), content: t('Copywriting.CryptocurrencySafe') },
    { id: 4, title: t('Title.HowFrequent'), content: t('Copywriting.HowFrequent') },
    { id: 5, title: t('Title.PostAnyContent'), content: t('Copywriting.PostAnyContent') },
    { id: 6, title: t('Title.FAQ6'), content: t('Copywriting.FAQ6') },
  ]
})
</script>
<template>
  <div class="sm:w-175 w-full mx-auto dark:bg-brandD pb-9 px-4 sm:px-0">
    <div class="text-7 leading-9 sm:text-8 sm:leading-10 mb-9">
      {{ t('Global.FrequentlyAskedQuestions') }}
    </div>

    <n-collapse arrow-placement="right">
      <template #arrow>
        <div class="rotate-180 sm:w-5.5 w-4 text-brandB" i-ph:caret-up-bold />
      </template>
      <div
        v-for="item in collapseList"
        :key="item.id"
        class="sm:mb-7.5 sm:pb-7.5 pb-5 mb-5 b-b df-b"
      >
        <n-collapse-item :name="item.id">
          <template #header>
            <div
              class="sm:text-4.5 text-4 leading-6 typeface-robotoMedium dark:text-brandC text-brandD"
            >
              {{ item.title }}
            </div>
          </template>
          <div
            v-html="item.content"
            class="sm:mt-3 mt-2 text-4 leading-6 dark:text-brandC text-brandD"
          />
        </n-collapse-item>
      </div>
    </n-collapse>
  </div>
</template>
